<template>
  <div class="container">

    <!--北向きカメラ-->
    <div class="contents-north" v-if="direction === 'north'">
      <img class="library-door-button-north" src="../../assets/img/building_a/corridor_btn_library.png" alt="図書室"
           @click="moveToLibrary">
      <img class="forward-button-north" src="../../assets/img/arrow.png" alt="進む" @click="moveToBoard">
      <img class="back-button-north" src="../../assets/img/arrow.png" alt="戻る" @click="moveToA12s">
    </div>

    <!--南向きカメラ-->
    <div class="contents-south" v-if="direction === 'south'">
      <img class="library-door-button-south" src="../../assets/img/building_a/corridor_btn_library.png" alt="図書室"
           @click="moveToLibrary">
      <img class="forward-button-south" src="../../assets/img/arrow.png" alt="進む" @click="moveToA12s">
      <img class="back-button-south" src="../../assets/img/arrow.png" alt="戻る" @click="moveToBoard">
    </div>
  </div>
</template>

<script>
  export default {
    name: "Corridor_a_1_1",
    data() {
      return {
        direction: undefined
      }
    },
    methods: {
      moveToLibrary() {
        this.$emit("play-sound", "audio/vrschool_se_select.mp3");
        this.$router.push("/library");
      },
      moveToBoard() {
        this.$emit("play-sound", "audio/vrschool_se_select.mp3");
        this.$router.push("/board");
      },
      moveToA12s() {
        this.$emit("play-sound", "audio/vrschool_se_select.mp3");
        this.$router.push("/corridor/a12s");
      }
    },
    created() {
      switch (this.$route.path) {
        case '/corridor/a11n':
          this.direction = 'north';
          break;
        case '/corridor/a11s':
          this.direction = 'south';
          break;
      }
    }
  }
</script>

<style scoped>

  /* 北向きカメラ */
  .contents-north {
    height: 100%;
    background: url("../../assets/img/building_a/corridor_a_1_1_n_bg.png") no-repeat fixed center;
    background-size: contain;

    -webkit-perspective: 50vw;
    -moz-perspective: 50vw;
  }

  .forward-button-north {
    position: absolute;
    left: 46%;
    bottom: 25%;
    width: 8%;
    cursor: pointer;
    animation: move-forward-arrow 3s ease-in-out infinite;
  }

  .back-button-north {
    position: absolute;
    left: 43%;
    bottom: 16px;
    width: 14%;
    cursor: pointer;
    animation: move-back-arrow 3s ease-in-out infinite;
  }

  .library-door-button-north {
    position: absolute;
    left: 21%;
    bottom: 34%;
    width: 18%;
    cursor: pointer;
    animation: float-left 3s ease-in-out infinite;
  }

  @keyframes float-left {
    0% {
      transform: translateY(0px) rotateX(0deg) rotateY(85deg);
    }
    50% {
      transform: translateY(-8px) rotateX(0deg) rotateY(85deg);
    }
    100% {
      transform: translateY(0px) rotateX(0deg) rotateY(85deg);
    }
  }

  /* 南向きカメラ */
  .contents-south {
    height: 100%;
    background: url("../../assets/img/building_a/corridor_a_1_1_s_bg.png") no-repeat fixed center;
    background-size: contain;

    -webkit-perspective: 50vw;
    -moz-perspective: 50vw;
  }

  .forward-button-south {
    position: absolute;
    left: 48%;
    bottom: 37%;
    width: 6%;
    cursor: pointer;
    animation: move-forward-arrow 3s ease-in-out infinite;
  }

  .back-button-south {
    position: absolute;
    left: 44%;
    bottom: 16px;
    width: 14%;
    cursor: pointer;
    animation: move-back-arrow 3s ease-in-out infinite;
  }

  .library-door-button-south {
    position: absolute;
    right: 11.5%;
    bottom: 34%;
    width: 22%;
    cursor: pointer;
    animation: float-right 3s ease-in-out infinite;
  }

  @keyframes float-right {
    0% {
      transform: translateY(0px) rotateX(-2deg) rotateY(-88deg);
    }
    50% {
      transform: translateY(-16px) rotateX(-2deg) rotateY(-88deg);
    }
    100% {
      transform: translateY(0px) rotateX(-2deg) rotateY(-88deg);
    }
  }

  /* 共通 */
  @keyframes move-forward-arrow {
    0% {
      transform: translateZ(32px) rotateX(70deg);
    }
    50% {
      transform: translateZ(0px) rotateX(70deg);
    }
    100% {
      transform: translateZ(32px) rotateX(70deg);
    }
  }

  @keyframes move-back-arrow {
    0% {
      transform: translateZ(0px) rotateX(-110deg);
    }
    50% {
      transform: translateZ(16px) rotateX(-110deg);
    }
    100% {
      transform: translateZ(0px) rotateX(-110deg);
    }
  }

</style>